import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { 
  TrendingUp, 
  TrendingDown, 
  BarChart3, 
  Eye,
  ChevronLeft,
  ChevronRight,
  DollarSign,
  PieChart,
  Wallet
} from 'lucide-react';

const API_BASE = 'http://localhost:8000';

const PortfolioPage = () => {
  const { user, logout, isAuthenticated, validateCurrentUser } = useAuth(); 
  const [portfolio, setPortfolio] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  
  console.info("Current User in Home page: ", user);
  const itemsPerPage = 10;

  // Mock RSA data for demonstration (replace with actual RSA calculation)
  const getRSAData = (symbol) => {
    const rsaValues = {
      'AAPL': { value: 65, status: 'overbought' },
      'GOOGL': { value: 35, status: 'oversold' },
      'TSLA': { value: 72, status: 'overbought' },
      'MSFT': { value: 45, status: 'neutral' },
      'AMZN': { value: 28, status: 'oversold' },
      'NVDA': { value: 68, status: 'overbought' },
      'JPM': { value: 52, status: 'neutral' },
      'V': { value: 38, status: 'oversold' },
      'DIS': { value: 61, status: 'overbought' },
      'NFLX': { value: 42, status: 'neutral' }
    };
    return rsaValues[symbol] || { value: 50, status: 'neutral' };
  };

  const fetchPortfolio = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE}/api/portfolio/getPortfolio`, {params:{tdSession:'true'}});
      setPortfolio(response.data.portfolio);
      setError(null);
    } catch (err) {
      setError('Failed to fetch portfolio data');
      console.error('Error:', err);
      
      // Mock data for demonstration
      setPortfolio([
        { symbol: 'AAPL', name: 'Apple Inc.', quantity: 25, average_cost: 145.32, market_price: 178.21, market_value: 4455.25, unrealized_pnl: 822.25, currency: 'USD' },
        { symbol: 'GOOGL', name: 'Alphabet Inc.', quantity: 10, average_cost: 2350.67, market_price: 2189.43, market_value: 21894.30, unrealized_pnl: -1612.40, currency: 'USD' },
        { symbol: 'TSLA', name: 'Tesla Inc.', quantity: 15, average_cost: 210.45, market_price: 245.67, market_value: 3685.05, unrealized_pnl: 528.30, currency: 'USD' },
        { symbol: 'MSFT', name: 'Microsoft Corp.', quantity: 20, average_cost: 285.12, market_price: 312.89, market_value: 6257.80, unrealized_pnl: 555.40, currency: 'USD' },
        { symbol: 'AMZN', name: 'Amazon.com Inc.', quantity: 8, average_cost: 145.67, market_price: 132.45, market_value: 1059.60, unrealized_pnl: -105.76, currency: 'USD' },
        { symbol: 'NVDA', name: 'NVIDIA Corp.', quantity: 12, average_cost: 345.78, market_price: 412.34, market_value: 4948.08, unrealized_pnl: 798.72, currency: 'USD' },
        { symbol: 'JPM', name: 'JPMorgan Chase', quantity: 30, average_cost: 145.67, market_price: 152.34, market_value: 4570.20, unrealized_pnl: 200.10, currency: 'USD' },
        { symbol: 'V', name: 'Visa Inc.', quantity: 18, average_cost: 234.56, market_price: 221.45, market_value: 3986.10, unrealized_pnl: -235.98, currency: 'USD' },
        { symbol: 'DIS', name: 'Walt Disney Co.', quantity: 25, average_cost: 95.43, market_price: 102.34, market_value: 2558.50, unrealized_pnl: 172.75, currency: 'USD' },
        { symbol: 'NFLX', name: 'Netflix Inc.', quantity: 15, average_cost: 345.67, market_price: 332.45, market_value: 4986.75, unrealized_pnl: -198.30, currency: 'USD' },
        { symbol: 'IBM', name: 'IBM Corp.', quantity: 20, average_cost: 145.67, market_price: 152.34, market_value: 3046.80, unrealized_pnl: 133.40, currency: 'USD' },
        { symbol: 'INTC', name: 'Intel Corp.', quantity: 35, average_cost: 45.67, market_price: 42.34, market_value: 1481.90, unrealized_pnl: -116.55, currency: 'USD' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.info("User, IsAutntigated, ValidatedUser", user, isAuthenticated, validateCurrentUser);
    // const validateAccess = async () => {
    //     // If not authenticated, redirect to login
    //     if (!isAuthenticated) {
    //         console.log('❌ Not authenticated, redirecting to login...');
    //         navigate('/login');
    //         return;
    //     }    
    //     // Validate user on dashboard load
    //     try {
    //         setLoading(true);
    //         const result = await validateCurrentUser();
    //         if (!result.success) {
    //             console.log('❌ User validation failed, redirecting to login...');
    //             navigate('/login');
    //             return;
    //         }
    //         console.log('✅ Dashboard access granted for:', result.user.email);
    //     } catch (error) {
    //         console.error('❌ Dashboard validation error:', error);
    //         navigate('/login');
    //     } finally {
    //         setLoading(false);
    //     }
    //   };    
    // validateAccess();        
    fetchPortfolio();
  }, [isAuthenticated, navigate, validateCurrentUser]);

  // Pagination calculations
  const totalPages = Math.ceil(portfolio.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = portfolio.slice(startIndex, startIndex + itemsPerPage);

  const handlePrediction = (symbol) => {
    console.log(`Prediction requested for: ${symbol}`);
    // Implement prediction logic here
    alert(`Price prediction analysis for ${symbol}`);
    if (symbol.trim()) {
      // Navigate to the ticker dashboard with the symbol
      navigate(`/prediction/${symbol.trim().toUpperCase()}`);
    }

  };

  const handleAnalystView = (symbol) => {
    console.log(`Analyst view requested for: ${symbol}`);
    // Implement analyst view logic here
    alert(`Analyst ratings and targets for ${symbol}`);
    if (symbol.trim()) {
      // Navigate to the ticker dashboard with the symbol
      navigate(`/stockAnalysis/${symbol.trim().toUpperCase()}`);
    }
  };

  const getRowBackgroundColor = (symbol) => {
    const rsaData = getRSAData(symbol);
    if (rsaData.status === 'overbought') {
      return 'bg-red-50 hover:bg-red-100'; // Light red for overbought
    } else if (rsaData.status === 'oversold') {
      return 'bg-green-50 hover:bg-green-100'; // Light green for oversold
    }
    return 'bg-gray-50 hover:bg-gray-100'; // Neutral
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  };

  const handleLogout = () => {
      logout();
      navigate('/login');
  };  

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading portfolio data...</p>
        </div>
      </div>
    );
  }

  if (!user) {
      navigate('/login');
      return null;
  }  

  return (
    
        <div className="min-h-screen bg-gray-100 py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Header */}
            <div className="bg-white rounded-lg shadow-md p-6 mb-8">
              <div className="flex items-center justify-between">
                <div>
                  <h1 className="text-3xl font-bold text-gray-900">📊 Investment Portfolio</h1>
                  <p className="text-gray-600 mt-2">Real-time portfolio tracking and analysis</p>
                </div>
                <div className="flex items-center space-x-4">
                  <button
                    onClick={fetchPortfolio}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center"
                  >
                    <Eye size={18} className="mr-2" />
                    Refresh Data
                  </button>
                </div>
              </div>
            </div>

            {/* Summary Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="flex items-center">
                  <div className="p-3 bg-blue-100 rounded-full">
                    <DollarSign className="text-blue-600" size={24} />
                  </div>
                  <div className="ml-4">
                    <p className="text-gray-600 text-sm">Total Value</p>
                    <p className="text-2xl font-bold text-gray-900">
                      {formatCurrency(portfolio.reduce((sum, item) => sum + item.market_value, 0))}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="flex items-center">
                  <div className="p-3 bg-green-100 rounded-full">
                    <TrendingUp className="text-green-600" size={24} />
                  </div>
                  <div className="ml-4">
                    <p className="text-gray-600 text-sm">Total P&L</p>
                    <p className={`text-2xl font-bold ${
                      portfolio.reduce((sum, item) => sum + item.unrealized_pnl, 0) >= 0 
                        ? 'text-green-600' 
                        : 'text-red-600'
                    }`}>
                      {formatCurrency(portfolio.reduce((sum, item) => sum + item.unrealized_pnl, 0))}
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="flex items-center">
                  <div className="p-3 bg-purple-100 rounded-full">
                    <PieChart className="text-purple-600" size={24} />
                  </div>
                  <div className="ml-4">
                    <p className="text-gray-600 text-sm">Total Stocks</p>
                    <p className="text-2xl font-bold text-gray-900">{portfolio.length}</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="flex items-center">
                  <div className="p-3 bg-orange-100 rounded-full">
                    <Wallet className="text-orange-600" size={24} />
                  </div>
                  <div className="ml-4">
                    <p className="text-gray-600 text-sm">Avg Return</p>
                    <p className="text-2xl font-bold text-gray-900">
                      {((portfolio.reduce((sum, item) => sum + (item.unrealized_pnl / item.market_value * 100), 0) / portfolio.length) || 0).toFixed(2)}%
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Portfolio Table */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Symbol
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Name
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Quantity
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Avg Cost
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Current Price
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Market Value
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        P&L
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        RSA Status
                      </th>
                      <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {currentItems.map((item, index) => {
                      const rsaData = getRSAData(item.symbol);
                      return (
                        <tr 
                          key={index} 
                          className={getRowBackgroundColor(item.symbol)}
                        >
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-bold text-gray-900">{item.symbol}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{item.name}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{item.quantity}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-900">{formatCurrency(item.average_cost)}</div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">
                              {formatCurrency(item.market_price)}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">
                              {formatCurrency(item.market_value)}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className={`text-sm font-medium ${
                              item.unrealized_pnl >= 0 ? 'text-green-600' : 'text-red-600'
                            }`}>
                              {formatCurrency(item.unrealized_pnl)}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                              rsaData.status === 'overbought' 
                                ? 'bg-red-100 text-red-800'
                                : rsaData.status === 'oversold'
                                ? 'bg-green-100 text-green-800'
                                : 'bg-gray-100 text-gray-800'
                            }`}>
                              {rsaData.status.toUpperCase()} ({rsaData.value})
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                            <div className="flex space-x-2">
                              <button
                                onClick={() => handlePrediction(item.symbol)}
                                className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-md text-xs flex items-center"
                              >
                                <TrendingUp size={14} className="mr-1" />
                                Prediction
                              </button>
                              <button
                                onClick={() => handleAnalystView(item.symbol)}
                                className="bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded-md text-xs flex items-center"
                              >
                                <BarChart3 size={14} className="mr-1" />
                                Analyst
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="bg-white px-6 py-4 border-t border-gray-200">
                  <div className="flex items-center justify-between">
                    <div className="text-sm text-gray-700">
                      Showing <span className="font-medium">{startIndex + 1}</span> to{' '}
                      <span className="font-medium">
                        {Math.min(startIndex + itemsPerPage, portfolio.length)}
                      </span>{' '}
                      of <span className="font-medium">{portfolio.length}</span> stocks
                    </div>
                    <div className="flex space-x-2">
                      <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className="px-3 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                      >
                        <ChevronLeft size={16} className="mr-1" />
                        Previous
                      </button>
                      <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className="px-3 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                      >
                        Next
                        <ChevronRight size={16} className="ml-1" />
                      </button>
                    </div>
                  </div>

                  {/* Page Numbers */}
                  <div className="flex justify-center mt-4 space-x-1">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-3 py-1 rounded-md text-sm font-medium ${
                          currentPage === page
                            ? 'bg-blue-600 text-white'
                            : 'text-gray-700 hover:bg-gray-100'
                        }`}
                      >
                        {page}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {error && (
              <div className="mt-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative">
                {error}
              </div>
            )}
          </div>
        </div>
  );
};

export default PortfolioPage;